import {useAtom} from "jotai";
import React, {useEffect, useState} from "react";
import {ModalBody, ModalHeader} from "../modal/Modal";
import styled from "styled-components";
import {
  mainColor, mainColorOpacity5, Site,
  subColor, textColor, TextMainColor, whiteColor
} from "../../assets/GlobalStyles";
import {modalController} from "../../store";
import {tokenResultAtom} from "../../pages/login/entity/Common";
export function WarningModal(props) {
  const {title, onSubmit, btnStyle} = props;
  const [, setModal] = useAtom(modalController)
  useEffect(()=>{
    return () => {
      setModal({isShow:false});
    }
  },[])
  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 600,
      modalComponent: () => {
        return (
          <Modal title={title} onSubmit={onSubmit}/>
        )
      }
    })
  }

switch (btnStyle){
  default : return <><Button type={'button'} onClick={handleModalComponent}>{title}<Site/></Button></>;
  }
}


function Modal (props) {
  const [, setModal] = useAtom(modalController)
  const [validation, setValidation] = useState('')
  const {title} = props;
  const handleSubmit = () => {
      setModal({
        isShow: false,
        modalComponent: null
      })
      props.onSubmit();
      setValidation('');
  }
  const handleCancle = () => {
      setModal({
        isShow: false,
        modalComponent: null
      })
      setValidation('');
  }

  return (
      <div>
        <ModalHeader title={title}/>
        <ModalBody style={{backgroundColor: '#fff'}}>
          <MediaSearchColumn>
            <CheckBoxDiv>
              <b>현재 진행 중인 캠페인 생성을 중단하고 다른 화면으로 이동하시겠습니까?</b>
              <label style={{marginTop: '20px', color: '#f55a5a'}}>
                <p >※ 지금 단계까지 입력한 내용은 자동으로 저장되며, 이후 다시 이어서 진행하실 수 있습니다.</p><br />
              </label>
            </CheckBoxDiv>
          </MediaSearchColumn>
          {validation !== '' && <Validation>{validation}</Validation>}
          <ButtonDiv>
            <NavigateButton type={'button'} onClick={handleSubmit}>{'이동하기'}</NavigateButton>
            <CancelButton type={'button'} onClick={handleCancle}>{'취소'}</CancelButton>
          </ButtonDiv>
        </ModalBody>
      </div>
  )
}

const MediaSearchColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  width: 100%;
  background-color: #FEF3F2;
  color: #fff;
  border-color: #FEE4E2;

  & > div:first-child {
    min-width: 70px;
  }

  & > div:last-child {
    width: 100%;
  }
`
const CheckBoxDiv = styled.div`
  & {
    color: ${textColor};
  }
  & > label > input{
    width: 40px;
    margin-right: 20px;
  }
`

const Button = styled.button`
  display: inline-flex;
  align-items: center;			/* 수직 정렬 */
  justify-content: center;		/* 수평 중앙 */
  gap: 6px;						/* title ↔ Site 간격 */

  width: 200px;
  padding-left: 10px;
  height: 40px;
  border-radius: 5px;
  background-color: ${mainColorOpacity5};
  color: ${TextMainColor};
  font-size: 15px;
  cursor: pointer;

  & svg {
    display: block;				/* 아이콘 baseline 문제 방지 */
  }

`

const ButtonDiv = styled.div`
  display: flex;
  justify-content: center; /* 가운데 정렬 */
  align-items: center;
  gap: 12px; /* 버튼 사이 간격 */
  margin-top: 15px;
`
const NavigateButton = styled.button`
  padding: 13px 0;
  width: 200px;
  background-color: ${mainColor};
  color: ${whiteColor};
`

const CancelButton = styled.button`
  padding: 13px 0;
  width: 200px;
  background-color: ${subColor};
  color: #ffffff;
`

const Validation = styled.div`
  margin-top: 10px;
  text-align: center;
  color: #f55a5a;
  font-size: 13px !important;
`